module.exports = __webpack_public_path__ + "img/noteTemplate.ce704fb6.jpeg";